import * as API_CONSTANT from '../constants'

export const getVAMEntryThruVID = (vid) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vam/entry/get/vid`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            vid
        })
    })
    .then(res => res.json())
)

export const CU_VAMEntry = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vam/entry/cu`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(items)
    })
    .then(res => res.json())
)

export const getVAMLine = (vamlt) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vam/line/item/get/vamlt`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            vamlt
        })
    })
    .then(res => res.json())
)

export const CU_VAMLine = (item, action) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vam/line/item/cu`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            ...item,
            action
        })
    })
    .then(res => res.json())
)

export const getVAMLineBatch = (vamlids) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vam/line/batch/get`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            vamlids
        })
    })
    .then(res => res.json())
)

export const getVAMLineTemplate = (vamltid) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vam/line/template/get`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            vamltid
        })
    })
    .then(res => res.json())
)

export const getVAMLineTemplateBatch = (vamltids) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vam/line/template/batch/get`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            vamltids
        })
    })
    .then(res => res.json())
)

export const getVAMProgram = (vampid) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vam/program/get`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            vampid
        })
    })
    .then(res => res.json())
)

export const getVAMProgramBatch = (vampids) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vam/program/batch/get`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            vampids
        })
    })
    .then(res => res.json())
)

export const getVAMReminderThruVID = (vid) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vam/reminder/get/vid`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            vid
        })
    })
    .then(res => res.json())
)

export const CU_VAMReminder = (item, actionAPI) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vam/reminder/cu`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            ...item,
            actionAPI
        })
    })
    .then(res => res.json())
)

export const getVAMSchedule = (vamsid) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vam/schedule/get`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            vamsid
        })
    })
    .then(res => res.json())
)

export const getVAMVehicleIssue = (vid) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vam/issue/get`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            vid
        })
    })
    .then(res => res.json())
)

export const getBatchVAMVehicleIssue = (vids) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vam/issue/batch/get`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            vids
        })
    })
    .then(res => res.json())
)

export const CUVAMVehicleIssue = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vam/issue/cu`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(items)
    })
    .then(res => res.json())
)

export const getCommentVAMVehicleIssue = (vamiid) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vam/issue/comment/get`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({vamiid})
    })
    .then(res => res.json())
)

export const cudCommentVAMVehicleIssue = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vam/issue/comment/cud`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(items)
    })
    .then(res => res.json())
)

export const cuVAMLineTypeByUID = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vam/line/type/cu`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(items)
    })
    .then(res => res.json())
)

export const getVAMLineTypeByUID = (uid) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vam/line/type/get/uid`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            uid
        })
    })
    .then(res => res.json())
)

export const getVAMEntryByTimeframe = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/vam/entry/timeframe/get`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(items)
    })
    .then(res => res.json())
)